/* eslint-disable @typescript-eslint/no-explicit-any */
// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { constants } from '../../modules';

import { WebPromptStaticBanner } from './WebPromptStaticBanner';

const WebPromptBanner = dynamic(() => import('./WebPromptBanner').then(mod => mod.WebPromptBanner));

export const WebPromptBannerConfig = {
  emptyLabel: 'WebPromptBanner',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/webpromptbanner`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WebPromptBannerEditable = (props: any) => (
  <EditableComponent config={WebPromptBannerConfig} {...props}>
    {String(props?.model?.webPromptBannerType ?? '').toUpperCase() === constants.STATIC ? (
      <WebPromptStaticBanner {...props} />
    ) : (
      <WebPromptBanner {...props} />
    )}
  </EditableComponent>
);
